import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Button, Icon, Tooltip } from 'antd';
import classNames from 'classnames';

import editDocumentActions from '../store/actions/edit-document.actions';
import documentEditMode from '../constants/documentEditMode';

import { ReactComponent as DocumentBellIcon } from '../../../resource/documents/DocumentBellIcon.svg';

import styles from './table.module.scss';

export const ExpandedRowDocReminder = ({ record }) => {
  const dispatch = useDispatch();

  return (
    <Tooltip
      title={`Напомнить`}
      placement="right"
    >
      <Button
        ghost
        shape="circle"
        onClick={(e) => {
          e.stopPropagation();
          dispatch(
            editDocumentActions.openModal({
              ...record,
              editMode: documentEditMode.REMINDER,
            })
          );
        }}
      >
        <Icon
          className={classNames(styles.icon, styles.reminderIcon)}
          component={DocumentBellIcon}
        />
      </Button>
    </Tooltip>
  );
};

ExpandedRowDocReminder.propTypes = {
  record: PropTypes.object.isRequired,
};
